export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';

export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAIL = 'USER_UPDATE_FAIL';

export const PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';
export const CLEAR_PASSWORD_STATE = 'CLEAR_PASSWORD_STATE';


export const USER_PREFERENCES_UPDATE_REQUEST = 'USER_PREFERENCES_UPDATE_REQUEST';
export const USER_PREFERENCES_UPDATE_SUCCESS = 'USER_PREFERENCES_UPDATE_SUCCESS';
export const USER_PREFERENCES_UPDATE_FAIL = 'USER_PREFERENCES_UPDATE_FAIL';

export const SET_JOYRIDE_NEXT = 'SET_JOYRIDE_NEXT';

export const USER_ME_REQUEST = 'USER_ME_REQUEST';
export const USER_ME_SUCCESS = 'USER_ME_SUCCESS';
export const USER_ME_FAIL = 'USER_ME_FAIL';
